import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import theme from "../theme";
import { ChangeEvent, useRef, useState } from "react";
import MultipleDeviceModal from "./multipleDeviceModal";
import { uploadResult } from "../types/types";
import { Button } from "./common/Button";
import { postMultipleDevices } from "../api/mobility";

const MultipleModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  icon: JSX.Element;
  title: string;
  content: string;
  onClose: any;
}> = (props) => {
  const { open, onPressNo, icon, title, content, onClose } = props;
  const fileDownloadRef = useRef<HTMLAnchorElement>(null);
  const fileUploadRef = useRef<HTMLInputElement>(null);
  const [openMultipleDeviceModal, setOpenMultipleDeviceModal] =
    useState(false);
  const [uploadResult, setUploadResult] = useState<uploadResult[]>();

  const handleFileDownload = () => {
    if (fileDownloadRef.current) {
      fileDownloadRef.current.click();
    }
  };

  const handleFileUpload = () => {
    if (fileUploadRef.current) {
      fileUploadRef.current.click();
    }
  };

  const handleFileInputChange = async (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0]; // Create a FormData object to send the file to the server
      const formData = new FormData();
      formData.append("file", file);
      const response = await postMultipleDevices(formData);
      if (response.code === 2002) {
        // console.log(response);
        setUploadResult(response?.result as uploadResult[]);
        setOpenMultipleDeviceModal(true);
      } else {
        // 실패 처리
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onPressNo}
      PaperProps={{
        sx: {
          // width: "513px",
          minWidth: "513px",
          maxWidtn: "513px",
          alignItems: "center",
          pt: "50px",
          borderRadius: "20px",
          pb: "60px",
        },
      }}
    >
      {icon}
      <DialogTitle
        sx={{
          width: "400px",
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "23px",
          mt: "14px",
          mb: "15px",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            padding: "16px 24px",
            width: "400px",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "23px",
            color: theme.color.neutral_600,
            whiteSpace: "pre-line",
            textAlign: "center",
            mb: "15px",
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <div
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <Button
          bgColor={theme.color.aquamarine_500}
          onClick={handleFileDownload}
          hoverColor={theme.color.aquamarine_600}
          style={{ width: "330px", height: "50px" }}
        >
          양식 다운로드 (Excel 파일)
        </Button>
        <Button
          onClick={handleFileUpload}
          bgColor={theme.statusColor.MAIN}
          hoverColor={theme.statusColor.MAIN_HOVER}
          style={{ width: "330px", height: "50px" }}
        >
          작성된 파일 업로드
        </Button>

        <input
          style={{ display: "none" }}
          type="file"
          ref={fileUploadRef}
          accept=".xlsx"
          onChange={handleFileInputChange}
        />
        <a
          style={{ display: "none" }}
          ref={fileDownloadRef}
          href={`${process.env.REACT_APP_BASE_URL}/file/form.xlsx`}
        />
      </div>
      <MultipleDeviceModal
        open={openMultipleDeviceModal}
        onClose={onClose}
        onPressNo={onPressNo}
        close={() => {
          setUploadResult(undefined);
          setOpenMultipleDeviceModal(false);
        }}
        data={uploadResult}
      />
    </Dialog>
  );
};

export default MultipleModal;
